import { render, staticRenderFns } from "./DevelopmentalCongenitalConditionBirthDefect.vue.vue?vue&type=template&id=0a5a899a&scoped=true"
import script from "./DevelopmentalCongenitalConditionBirthDefect.vue.vue?vue&type=script&lang=js"
export * from "./DevelopmentalCongenitalConditionBirthDefect.vue.vue?vue&type=script&lang=js"
import style0 from "./DevelopmentalCongenitalConditionBirthDefect.vue.vue?vue&type=style&index=0&id=0a5a899a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a5a899a",
  null
  
)

export default component.exports